import { BRAND_CONFIG } from '@@brand'
import { URL_MAIN_PAGE } from '@shared/contants'
import { cn } from '@shared/lib/cn'
import { LocalizedLink as Link } from '@shared/lib/locale'

import styles from './styles.module.scss'


interface LogoProps {
  className?: string;
}

export default function Logo (props: LogoProps) {
  const { className } = props

  return (
    <Link className={cn(styles.root, className)} to={URL_MAIN_PAGE}>
      <img src={BRAND_CONFIG.images.logo} alt={BRAND_CONFIG.name} loading="lazy" fetchPriority="low" />
    </Link>
  )
}
